/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import classNames from 'classnames';

import Icon from '../../../shared/widget/icon';
import { ParkHighlights } from '../../../../types/shared/parkHighlights';
import styles from './accommodation-features-v1.module.scss';

type Props = {
  featurePills: ParkHighlights[];
};

export const AccommodationFeaturesV1 = ({ featurePills }: Props) => {
  const [showAllFeatures, setShowAllFeatures] = useState(false);

  const features = showAllFeatures && featurePills ? featurePills : featurePills.slice(0, 3);
  const featurePillsCount = featurePills.length;

  const isAccommodationWidth = (featurePill: ParkHighlights, index: number) => {
    return featurePill.title.toLowerCase().includes('wide') && index === 0;
  };

  return (
    <ul className={styles.additionalFeatures}>
      {features.map((featurePill, index) => (
        <li
          key={index}
          className={classNames(styles.accommodationFeaturePill, {
            [styles.accommodationWidth]: isAccommodationWidth(featurePill, index),
          })}
        >
          {featurePill?.image?.url && (
            <Icon src={featurePill?.image?.url || ''} alt="" role="presentation" />
          )}
          <div className={styles.featureTitle}>{featurePill.title}</div>
        </li>
      ))}
      {featurePillsCount > 5 && (
        <button
          type="button"
          onClick={() => setShowAllFeatures(!showAllFeatures)}
          className={styles.remainingPills}
        >
          {showAllFeatures ? '- hide' : `+ ${featurePillsCount} more`}
        </button>
      )}
    </ul>
  );
};
